"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _TemperatureField = _interopRequireDefault(require("./TemperatureField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Row = _ref => {
  let {
    equipmentType,
    displayNameId,
    thingPDIDDevice,
    name = ''
  } = _ref;
  const tVDisplayNameId = (0, _reactRedux.useSelector)(store => {
    var _selectors$getActiveT;
    return (_selectors$getActiveT = _paulCorePackage.selectors.getActiveTranslationsValues(store)) === null || _selectors$getActiveT === void 0 || (_selectors$getActiveT = _selectors$getActiveT[equipmentType]) === null || _selectors$getActiveT === void 0 ? void 0 : _selectors$getActiveT.displayNameId;
  });
  const temperatureTranslateText = tVDisplayNameId === null || tVDisplayNameId === void 0 ? void 0 : tVDisplayNameId[displayNameId];
  const title = (0, _react.useMemo)(() => {
    return "".concat(name, " (").concat(temperatureTranslateText || '--', ")");
  }, [name, temperatureTranslateText]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.TableRow, {
    sx: {
      '&:last-child td, &:last-child th': {
        border: 0
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    align: "left"
  }, title || '--'), /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_TemperatureField.default, {
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: displayNameId
  }))), [title, thingPDIDDevice, displayNameId]);
};
exports.Row = Row;